import React, { useState, useEffect } from 'react'
import { Row, Col, Card, Carousel, Modal } from 'antd';
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Fancybox } from "@fancyapps/ui";
import { Link } from 'react-router-dom';
import { About_Us, Amarendra_Khatua, ani, Bader_Uddin, BusinessStandard, ceo, DailyHunt, favicon, gallery_1, gallery_10, gallery_11, gallery_12, gallery_13, gallery_14, gallery_15, gallery_16, gallery_17, gallery_18, gallery_19, gallery_2, gallery_20, gallery_21, gallery_22, gallery_23, gallery_24, gallery_25, gallery_26, gallery_27, gallery_28, gallery_3, gallery_4, gallery_5, gallery_6, gallery_7, gallery_8, gallery_9, IATA_Certificate_2025, india_map_dot, iso, iso_iec, Pratyush_Kumar, Shaquib_Raza, the, ThePrint, What_We_Offer_background } from '../../utils/ImagePath';
import { FaChevronDown, FaChevronUp, FaFacebookF, FaGlobeEurope, FaInstagram, FaLinkedinIn, FaTwitter, FaYoutube } from 'react-icons/fa';
import CertificatesCarousel from './CertificatesCarousel';
import Seo from '../helmet/Helmet';


function AboutUs() {

    // Initialize state to track visibility of each paragraph
    const [showFullText, setShowFullText] = useState({
        paragraph1: false,
        paragraph2: false,
        paragraph3: false,
        paragraph4: false,
        paragraph5: false,
        paragraph6: false,
        paragraph7: false,
        paragraph8: false,
        paragraph9: false,
        paragraph10: false,
        paragraph11: false,
        paragraph12: false,
        paragraph13: false,
    });

    // Toggle visibility of a specific paragraph
    const toggleText = (section) => {
        setShowFullText((prevState) => ({
            ...prevState,
            [section]: !prevState[section]
        }));
    };

    // Menagement section
    const toggleText2 = (paragraphKey) => {
        setShowFullText((prevState) => ({
            ...prevState,
            [paragraphKey]: !prevState[paragraphKey],
        }));
    };

    const members = [
        {
            name: "Mr. Afroz Ahmed",
            title: "Co-Founder and Managing Director",
            image: "https://seplgroup.com/assets/images/mang1.png",
            shortText:
                "Mr. Ahmed is the Co-Founder and Managing Director of Superb Enterprises Pvt Ltd – SEPL group of Companies of which SuperbWorldTrip Pvt Ltd. is part of. The other companies in the Group incl...",
            fullText1: "Mr. Ahmed is the Co-Founder and Managing Director of Superb Enterprises Pvt Ltd – SEPL group of Companies of which SuperbWorldTrip Pvt Ltd. is part of. The other companies in the Group include:",
            fullText2: "SEPL Document Clearing LLC , Dubai(UAE), Superb Infotech, Superb Associates (Legal Services), SEPL Bricks Pvt. Ltd., Superb Hotels, Hyderabad.",
            fullText3: "He has experience of more than 20 years in the field of travel and tourism and global outsourcing service business and overseas recruitment as well as dealing with Government of India and foreign diplomatic Missions in India. An entrepreneur at heart, he started the business in the year 2008 and is the driving force behind successfully creating SEPL Group Companies. The SEPL group has presence in all the important cities in India and an overseas office in Dubai. With his business acumen, he formulates the strategy, business planning and policies of the group. He is known for his passion for excellence and talent for resourceful business solutions. He leads the team to win new business, shape market opportunities by building alliances and partnerships and solidify the company's position in the industry. He believes in building positive relationships, giving premium value to the customers and to uphold the highest standards of integrity, in all aspects of our services. That will ensure the progress of SuperbWorldTrip as the best known travel brand in the country. Mr. Afroz is recognized by one and all in the industry as a professional with a high degree of personal integrity.",
        },

        {
            name: "Mr. Syed Mahmood Akhter, IRS(retd) ",
            title: "CEO - Superb World Trip",
            image: ceo,
            shortText:
                "Former, Joint Secretary/Commissioner(Customs & Central Excise), Mr. Akhter has over 35 years of experience in bureaucracy, revenue augmentation and management, soft power diplomacy an...",
            fullText1: "Former, Joint Secretary/Commissioner(Customs & Central Excise), Mr. Akhter has over 35 years of experience in bureaucracy, revenue augmentation and management, soft power diplomacy and trade negotiation. Widely travelled across Europe, USA, South East Asia, UAE, Saudi Arabia and SAARC countries, including a stint as Trade and Commerce Counselor at Indian consulate in Nepal. In order to foster the growth of the company's business, Mr. Akhter has contributed his creative energy, boundless passion, and exceptional networking skills. He envisions SuperworldTrip as one of the best knowm travel portals, which he believes can be achieved by strategic business development, to which he is focused.",
        },
        {
            name: "Mr. Amarendra Khatua, IFS (Retd.)",
            title: "Strategic Planning Advisor",
            image: Amarendra_Khatua,
            shortText:
                "Former Secretary, Ministry of External Affairs (Govt. Of India), Former Director General, Indian Council for Cultural Affairs; former Dean, Foreign Service Institute of India and former Ambassad...",
            fullText1: "Former Secretary, Ministry of External Affairs (Govt. Of India), Former Director General, Indian Council for Cultural Affairs; former Dean, Foreign Service Institute of India and former Ambassador of India to Argentina, Uruguay, Paraguay, Ivory Coast, Guinea, Liberia and Sierra Leone. His experience in India includes service in the Ministry of Commerce and Industry and Planning Commission and in the Finance, Administration, Latin Americas and Nepal, Bhutan divisions of Ministry of External Affairs. A widely travelled man, Ambassador Khatua’s years of experience worldwide, as well as in India, gives him a strategic eye on the tourism industry and what moves it. He brings in his knowledge to guide and help plan the Company’s mission to make SuperWorldTrip the most recognized travel brand in the country.",
        },
        {
            name: "Mr. Anil Kumar Kapila, IFS(Retd)",
            title: "Executive Director",
            image: "https://seplgroup.com/assets/images/mang2.png",
            shortText:
                "Former Director in the Ministry of External Affairs, Mr. Kapila has successfully and skillfully handled varied positions in the Consular, Passport & Visa, Security, Gulf, Protocol, and Establishment Wings in the...",
            fullText1: "Former Director in the Ministry of External Affairs, Mr. Kapila has successfully and skillfully handled varied positions in the Consular, Passport & Visa, Security, Gulf, Protocol, and Establishment Wings in the Ministry. He also served as Regional Passport Officer, Delhi and as Addl. P.S. to External Affairs Minister/Minister of State. He has held different positions in Indian Missions abroad in various capacities, i.e., Administration in Embassy of India, Rome, High Commission of India, Bangladesh, Consular( Passports, Visa & Commercial )in Consulate General of India, Dubai Head of Chancery in Embassy of India, Brasilia Counselor, Visa/Head of Chancery in High Commission of India, London. With SuperbWorldTrip since 2015, Mr. Kapila has been one of the leaders in the company helping it to attain its present prominence. It is his vision to make SuperWorldTrip the best travel portal where the customer is at the centre stage, who will be able to seamlessly navigate and fulfill any of his travel needs. Mr. Kapila likes to work in a challenging atmosphere that provides ample opportunities to keep learning in new areas for growth and to utilize his skills to the best of ability and explore all the possibilities to achieve excellence. He always believed in the team work and has done so in all the organizations, he is patient in listening to and dealing with others.",
        },

        {
            name: "Mr. Subir Dutta, IFS(retd)",
            title: "Director (HR)",
            image: "https://seplgroup.com/assets/images/mang7.png",
            shortText:
                "Former Ambassador of India to Madagascar and Union of Comoros, Mr. Dutta has over 35 years of experience of serving in the Ministry of External Affairs and in various Indian Embassies abro...",
            fullText1: "Former Ambassador of India to Madagascar and Union of Comoros, Mr. Dutta has over 35 years of experience of serving in the Ministry of External Affairs and in various Indian Embassies abroad. His area of work included passport and visas, information, tourism and publicity, HR and administration as well as politics and diplomacy in various stints in Embassies in Madagascar, Germany, South Korea, Kuwait, Israel, Thailand and Laos. He worked in the administration wing of the Ministry for quite some time besides dealing with politics and developmental assistance in Nepal and countries in West Asia and North Africa. Ambassador Dutta has come on board with his experience and is focused on developing a team geared to cater to the needs of travelers. He knows that travel is a service centric industry and building a team whose main focus is the travelllor is the only way for the company’s progress to greater heights.",
        },
        // {
        //     name: "Mr. Syed Mahmood Akhter, IRS(retd) ",
        //     title: "CEO - Superb World Trip",
        //     image: ceo,
        //     shortText:
        //         "Former, Joint Secretary/Commissioner(Customs & Central Excise), Mr. Akhter has over 35 years of experience in bureaucracy, revenue augmentation and management, soft power diplomacy an...",
        //     fullText1: "Former, Joint Secretary/Commissioner(Customs & Central Excise), Mr. Akhter has over 35 years of experience in bureaucracy, revenue augmentation and management, soft power diplomacy and trade negotiation. Widely travelled across Europe, USA, South East Asia, UAE, Saudi Arabia and SAARC countries, including a stint as Trade and Commerce Counselor at Indian consulate in Nepal. In order to foster the growth of the company's business, Mr. Akhter has contributed his creative energy, boundless passion, and exceptional networking skills. He envisions SuperworldTrip as one of the best knowm travel portals, which he believes can be achieved by strategic business development, to which he is focused.",
        // },
        {
            name: "Mr. Syed Tufail Ahmad",
            title: "General Manager",
            image: "https://seplgroup.com/assets/images/mang5.png",
            shortText:
                "Having joined the company in August 2016, Mr. Tufail Ahmad has been looking after the business development. He has over 18 years of experience and related fields specializing in recruitment, busi...",
            fullText1: "Having joined the company in August 2016, Mr. Tufail Ahmad has been looking after the business development. He has over 18 years of experience and related fields specializing in recruitment, business development in HR issues. His dynamism and affable personality combine to take the company to greater heights. He is focussed on business development initiatives to enhance company revenue streams. He is strong on maintaining relationship and market analysis. He holds an MPhil degree in Management and is an MBA in HR from Osmania University.",
        },
        {
            name: "Mr. Shaquib Raza Ansari",
            title: "Manager - Operations",
            image: Shaquib_Raza,
            shortText:
                "Mr. Shaquib Raza Ansari is in charge of operations in SuperbWorldTrip since September 2019. He has close to 18 years of experience in the travel industry and is experienced in all aspects of the trade includ...",
            fullText1: "Mr. Shaquib Raza Ansari is in charge of operations in SuperbWorldTrip since September 2019. He has close to 18 years of experience in the travel industry and is experienced in all aspects of the trade including ticketing, reservations, client management and travel consultancy. He also comes with knowledge of corporate travel operations in an international setting. He is well-versed in every aspect of the travel industry, and his strong points include customer service and retention, operations and delivery. His vision is to ensure optimum service to each travelor so that no one leaves SuperbWorldTrip unhappy. Mr. Ansari is a computer applications graduate and holds an MBA degree on information technology.",
        },
        {
            name: "Mr. Pratyush Kumar",
            title: "Branch Manager, Chennai.",
            image: Pratyush_Kumar,
            shortText:
                "Mr. Kumar joined the company in February, 2020 and has since been managing the Chennai branch. He brings with him over 13 years of experience in the travel and tourism industry in dealing with MIC...",
            fullText1: "Mr. Kumar joined the company in February, 2020 and has since been managing the Chennai branch. He brings with him over 13 years of experience in the travel and tourism industry in dealing with MICE, outbound operations, client relationship management etc. He is tasked with developing customer centric ideas and innovations for every travelor. He has been on the forefront creating innovative packages for enhancing customer experiences. He is a graduate in Tourism studies, holds a PGDM in Travel and Tourism Management as well as a Diploma in Aviation Hospitality and Travel management.",
        },
        {
            name: "Mr. Mohd. Bader Uddin (Aamir)",
            title: "Sr. Sales Manager, Hyderabad.",
            image: Bader_Uddin,
            shortText:
                "Mohd. Bader Uddin (Aamir) has been with the company for over a year and has been instrumental in forging substantial increase in sales. He comes with 14 years of experience in the hospitality indu...",
            fullText1: "Mohd. Bader Uddin (Aamir) has been with the company for over a year and has been instrumental in forging substantial increase in sales. He comes with 14 years of experience in the hospitality industry including international experience in a Sheraton chain hotel. He has extensive know-how in corporate travel and MICE tourism. SWT draws on his knowledge for group travels. He aims to use engaging social media content, innovative payment solutions and a personalised booking experience to increase sales.",
        },
        // Add similar objects for other members
    ];

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedMember, setSelectedMember] = useState(null);
    
    const openModal = (member) => {
        setSelectedMember(member);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedMember(null);
    };


    // Gallery section start
    useEffect(() => {
        // Initialize Fancybox
        Fancybox.bind("[data-fancybox]", {});

        return () => {
            // Clean up Fancybox instance
            Fancybox.destroy();
        };
    }, []);


    const Certificates = [
        {
            image: iso,
        },
        {
            image: iso_iec,
        },
        {
            image: IATA_Certificate_2025,
        },
        {
            image: "https://d1dejdv71ksru4.cloudfront.net/media/holiday/original/tamilnaducertificate.avif",
        },
    ];

    return (
        <>
            <Seo
                title="SuperbWorldTrip – About Us | Your Superb Travel Partner"
                description=" Discover SuperbWorldTrip, where we superb travel easy. Book domestic & international flights, hotels, and holidays at great prices with confidence."
                link="/offers"
                keywords=" Discover SuperbWorldTrip, where we superb travel easy. Book domestic & international flights, hotels, and holidays at great prices with confidence."
                largeTwitterCard={true}
                addPostfixTitle={false}
                noIndex={true}
            />

            <div className='bg-white pt-md-3' style={{ borderBottom: '1px solid #ddd' }}>
                <section className='about_section mb-md-5 mb-3'>
                    <div className='container'>
                        <Row gutter={16} align="middle text-center">
                            <Col md={3}></Col>
                            <Col md={18} sm={24}>
                                <div className='Package-cntr'>
                                    <h2 className=''>About Us</h2>
                                    <p>At SuperbWorldTrip, we make travel simple and affordable. Whether you're booking flights, hotels, or holiday packages services, we offer a seamless experience to meet your needs.</p>
                                </div>
                            </Col>
                            <Col md={24} className='banner_btn d-none'>
                                <a href="#">Home</a>
                                <a href="#" className='active'>About</a>
                            </Col>
                        </Row>
                    </div>
                </section>

                <section className='about_cntr'>
                    <div className='container'>
                        <Row gutter={16} className='align-items-center'>
                            <Col md={1}></Col>
                            <Col md={5} xs={24}>
                                <div className='achievement'>
                                    <div>
                                        <h2>3M+</h2>
                                        <p>Customers</p>
                                    </div>
                                    <div>
                                        <h2>65+</h2>
                                        <p>Industry</p>
                                    </div>
                                    <div>
                                        <h2>13k+</h2>
                                        <p>Travel</p>
                                    </div>
                                </div>
                            </Col>
                            <Col md={1}></Col>
                            <Col md={7}>
                                <img loading="lazy" src={About_Us} alt="#" className="img-fluid" />
                                <div className="circle-text">
                                    <div className="circle-text-img"></div>
                                    <figure className="circle-img">
                                        <img loading="lazy" src={favicon} alt="circle-img" className="img-responsive d-none" />
                                        <FaGlobeEurope className='text-primary' />
                                    </figure>
                                </div>
                            </Col>

                            <Col md={9} className='ps-md-4'>
                                <span className='title'>About Company</span>
                                <h3>Who We Are</h3>
                                <p>Founded in 2013, SuperbWorldTrip (earlier known as SuperbMyTrip) started its journey from a humble beginning with the prime objective of providing simplified domestic and international travel solutions to customers nationwide. Initial challenges were met with determination, perseverance and a firm belief in our company's vision. Today, after a decade of its inception, SuperbWorldTrip continues to be committed to making our customers travel experience easy, satisfying, and enjoyable by offering them honest prices and first-rate service.</p>
                                {showFullText.paragraph12 ? (
                                    <>
                                        <p>SuperbWorldTrip has a user-friendly and modern online travel portal to facilitate seamless bookings. Users can access our wide range of travel solutions with just a few clicks. Our in-house tech team is continually focused on maintaining and upgrading a secure, cutting-edge and scalable technology infrastructure and software. We also have a dedicated team of travel experts who are available round-the-clock to enable quick response and efficient services.</p>
                                    </>
                                ) : (
                                    <>

                                    </>
                                )}
                                <button className='read_btn' onClick={() => toggleText('paragraph12')} aria-label="read more">
                                    {showFullText.paragraph12 ? (
                                        <>
                                            Read Less <FaChevronUp />
                                        </>
                                    ) : (
                                        <>
                                            Read More <FaChevronDown />
                                        </>
                                    )}
                                </button>
                            </Col>
                        </Row>
                    </div>
                </section>

                <section className='what_we_offer ptb-70'>
                    <img loading="lazy" src={What_We_Offer_background} className='background-overlay fluid' alt='backgound' />
                    <div className='container'>
                        <Row gutter={16}>
                            <Col md={12}>

                                <h3>What We Offer</h3>
                                <p>
                                    We offer a wide range of online travel solutions including the most popular tourism products and services. Our vast collection of travel solutions is designed carefully to meet all your needs and make your journey smooth and hassle-free. We take the stresses out of travel planning.
                                </p>
                            </Col>
                            <Col md={12}>
                                <ul>
                                    <li><b>Flights</b> - We have affordable, but convenient flight options for any of your destinations. SuperbWorldTrip offers the best deals and discounts on domestic and international flights. Customers can take advantage of these deals through our seamless booking portal.</li>
                                    <li><b>Hotels</b> - Whether your destination is in India or anywhere in the world, we offer a wide range of selections carefully picked to fit every budget. Irrespective of whether you are looking for luxury or you are in search of comfort on a budget, we have something for everyone.</li>
                                    <li><b>Tour Packages</b> - Every customer can enjoy tailor-made packages that suit their needs. Whether you seek adventure, leisure or a pilgrimage tour, we have you covered at SuperbWorldTrip. You may have a dream destination, either in India or internationally, which you really want to explore. If so, let us do the homework and curate a travel package for you to fulfill your dream.</li>
                                </ul>
                            </Col>
                            <Col span={24}>
                                <img loading="lazy" src='https://images.pexels.com/photos/346885/pexels-photo-346885.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2' alt="#" className="who-we-are-img img-fluid" />
                            </Col>
                        </Row>
                    </div>
                </section>

                <section className='why_choose_us ptb-70'>
                    <div className='container'>
                        <Row gutter={16}>
                            <Col md={12}>
                                <div className='content_area'>
                                    <h3>Why Choose Us?</h3>
                                    <p>
                                        Personalised Service for Unforgettable Journeys
                                    </p>
                                    {showFullText.paragraph11 ? (
                                        <>
                                            <ul>
                                                <li><span>1</span> <b>The Traveler is the King</b> - You, the traveler are at the centre of our attention. We stand to fulfill your wishes by taking over all the formalities/hassles of organizing your travel and leaving you to just enjoy the travel experience.</li>
                                                <li><span>2</span> <b>Easy Booking</b> - SuperbWorldTrip tirelessly works to create the best booking experience for the users. Using our portal, you can securely book flights, hotels, buses and more with great offers.</li>
                                                <li><span>3</span> <b>Low Cost</b> - We provide competitive low-cost deals on all your travel bookings.</li>
                                                <li><span>4</span> <b>Amazing Deals</b> - Enjoy huge discounts and amazing offers when booking flights, hotels, buses, tour packages and more with SuperbWorldTrip.</li>
                                                <li><span>5</span> <b>24x7 Customer Service</b> - As a result of our customer-centric approach we have a professional team of experts available 24x7 to answer all your travel queries.</li>
                                                <li><span>6</span> <b>Personalized Services</b> - SuperbWorldTrip offers an option to customize every detail of a trip according to the user's preference.</li>
                                            </ul>
                                        </>
                                    ) : (
                                        <>
                                            <ul>
                                                <li><span>1</span> <b>The Traveler is the King</b> - You, the traveler are at the centre of our attention. We stand to fulfill your wishes by taking over all the formalities/hassles of organizing your travel and leaving you to just enjoy the travel experience.</li>
                                                <li><span>2</span> <b>Easy Booking</b> - SuperbWorldTrip tirelessly works to create the best booking experience for the users. Using our portal, you can securely book flights, hotels, buses and more with great offers.</li>
                                                <li><span>3</span> <b>Low Cost</b> - We provide competitive low-cost deals on all your travel bookings.</li>
                                                <li><span>4</span> <b>Amazing Deals</b> - Enjoy huge discounts and amazing offers when booking flights, hotels, buses, tour packages an...</li>
                                            </ul>
                                        </>
                                    )}


                                    <button className='read_btn' onClick={() => toggleText('paragraph11')} aria-label="read less">
                                        {showFullText.paragraph11 ? (
                                            <>
                                                Read Less <FaChevronUp />
                                            </>
                                        ) : (
                                            <>
                                                Read More <FaChevronDown />
                                            </>
                                        )}
                                    </button>
                                </div>
                            </Col>
                            <Col md={12}>
                                <img loading="lazy" src='https://images.pexels.com/photos/725255/pexels-photo-725255.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2' alt="#" className="img-fluid" />
                            </Col>
                        </Row>
                    </div>
                </section>

                <section className='who_we_are'>
                    <div className='container'>
                        <Row gutter={16} className='flex-row-reverse'>
                            <Col md={12}>
                                <div className='ps-md-4'>
                                    <h3>Our Mission for Our Vision</h3>
                                    <p className=''>At SuperbWorldTrip, we are dedicated to becoming the leading online travel solution in the country by providing excellent user experience with the help of a customer-centric approach and advanced tech tools. Our founder’s dream of SuperbWorldTrip being the country’s most well recognized travel brand is the goal.</p>
                                    <p>We aim to craft personalized journeys for our customers - whether you are a business or leisure traveler. Satisfying a business traveler’s needs of flexible itinerary, easy booking process, security, quick access to venues etc. is our forte. We curate holidays that inspire and connect travelers with the immense beauty and diversity of India and beyond. Irrespective of whether you seek adventure or relaxation, we have something for everyone.</p>
                                    <p className=''>Our mission is to make all your travel dreams cherished memories!</p>
                                </div>
                            </Col>
                            <Col md={12}>
                                <img loading="lazy" src='https://images.pexels.com/photos/7688460/pexels-photo-7688460.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2' alt="#" className="img-fluid" />
                            </Col>
                        </Row>
                    </div>
                </section>

                <section className='working_area'>
                    <div className='container'>
                        <Row gutter={20}>
                            <Col md={24}>
                                <div className='map_are'>

                                    <h2 className='fs-1 mb-5 text-center'>Our <span className='text-primary'>Offices</span></h2>
                                    <Row gutter={20} className='align-items-center'>
                                        <Col md={3}></Col>
                                        <Col md={12}>
                                            <img loading="lazy" src={india_map_dot} alt="" className='img-fluid' />
                                        </Col>
                                        <Col md={2}></Col>
                                        <Col md={7}>
                                            <div className='location_list'>
                                                <ul>
                                                    <li><span>1</span> Chandigarh</li>
                                                    <li><span>2</span> Jalandhar (Punjab)</li>
                                                    <li><span>3</span> New Delhi</li>
                                                    <li><span>4</span> Lucknow (UP)</li>
                                                    <li><span>5</span> Ahmedabad</li>
                                                    <li><span>6</span> Bhopal</li>
                                                    <li><span>7</span> Kolkata</li>
                                                    <li><span>8</span> Mumbai (Maharastra)</li>
                                                    <li><span>9</span> Pune (Maharastra)</li>
                                                    <li><span>10</span> Goa</li>
                                                    <li><span>11</span> Chennai (Tamilnadu)</li>
                                                    <li><span>12</span> Bangalore (Karnataka)</li>
                                                    <li><span>13</span> Kochi (Kerala)</li>
                                                    <li><span>14</span> Trivandrum (Kerala)</li>
                                                </ul>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>

                <section className='container-fluid team_management ptb-70 pb-md-5' style={{ width: '96%', margin: '60px auto' }}>

                    <Row gutter={20} className='headline_cntr text-center mb-5'>
                        <Col md={3}> </Col>
                        <Col md={18}>
                            <h2 className="title mb-2">Meet The Management</h2>
                            <p>Meet the visionary leaders behind SuperbWorldTrip! Our management comprises industry veterans who bring decades of experience, passion, and innovation into every journey we curate. Their commitment to delivering exceptional travel experiences lies at the heart of everything we do.</p>
                        </Col>
                    </Row>
                    <Row gutter={20}>
                        {members.map((member, index) => (
                            <Col md={12} key={index}>
                                <div
                                    className={`member_card ${showFullText[`paragraph${index}`] ? 'active' : ''}`}
                                >
                                    <img
                                        src={member.image}
                                        alt=""
                                        width={200}
                                        className="member_img"
                                    />
                                    <div>
                                        <h2>{member.name}</h2>
                                        <h4 className="mb-2">{member.title}</h4>
                                        <p>
                                            {showFullText[`paragraph${index}`] ? (

                                                <span>
                                                    {member.fullText1}
                                                    <b>{member.fullText2}</b>
                                                    {member.fullText3}
                                                </span>

                                            ) : (
                                                <span>{member.shortText}</span>
                                            )}
                                        </p>
                                        <button
                                            className="read_btn"
                                            onClick={() => openModal(member)}
                                        >
                                            Read More <FaChevronDown />
                                        </button>

                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                    <Row gutter={20} className='d-none'>
                        <Col md={12}>
                            <div className='member_card'>
                                <img loading="lazy" src="https://seplgroup.com/assets/images/mang1.png" alt="" width={200} className='member_img' />
                                <div>
                                    <h2>Mr. Afroz Ahmed</h2>
                                    <h4 className='mb-2'>Co-Founder and Managing Director</h4>
                                    <p>
                                        {showFullText.paragraph1 ? (
                                            <>
                                                Mr. Ahmed is the Co-Founder and Managing Director of Superb Enterprises Pvt Ltd – SEPL group of Companies of which SuperbWorldTrip Pvt Ltd. is part of. The other companies in the Group include:

                                                <br /><br />
                                                <b>SEPL Document Clearing LLC , Dubai(UAE),
                                                    Superb Infotech,
                                                    Superb Associates (Legal Services),
                                                    SEPL Bricks Pvt. Ltd.,
                                                    Superb Hotels, Hyderabad.</b>
                                                <br /><br />
                                                He has experience of more than 20 years in the field of travel and tourism and global outsourcing service business and overseas recruitment as well as dealing with Government of India and foreign diplomatic Missions in India. An entrepreneur at heart, he started the business in the year 2008 and is the driving force behind successfully creating SEPL Group Companies. The SEPL group has presence in all the important cities in India and an overseas office in Dubai. With his business acumen, he formulates the strategy, business planning and policies of the group. He is known for his passion for excellence and talent for resourceful business solutions. He leads the team to win new business, shape market opportunities by building alliances and partnerships and solidify the company's position in the industry. He believes in building positive relationships, giving premium value to the customers and to uphold the highest standards of integrity, in all aspects of our services. That will ensure the progress of SuperbWorldTrip as the best known travel brand in the country. Mr. Afroz is recognized by one and all in the industry as a professional with a high degree of personal integrity.
                                            </>
                                        ) : (
                                            <>
                                                Mr. Ahmed is the Co-Founder and Managing Director of Superb Enterprises Pvt Ltd – SEPL group of Companies of which SuperbWorldTrip Pvt Ltd. is part of. The other companies in the Group incl...
                                            </>
                                        )}
                                    </p>

                                    <button className='read_btn' onClick={() => toggleText('paragraph1')} aria-label="less">
                                        {showFullText.paragraph1 ? (
                                            <>
                                                Read Less <FaChevronUp />
                                            </>
                                        ) : (
                                            <>
                                                Read More <FaChevronDown />
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className='member_card'>
                                <img loading="lazy" src="https://seplgroup.com/assets/images/mang2.png" alt="" width={200} className='member_img' />
                                <div>
                                    <h2>Mr. Anil Kumar Kapila, IFS(Retd)</h2>
                                    <h4 className='mb-2'>Executive Director.</h4>
                                    <p>
                                        {showFullText.paragraph2 ? (
                                            <>
                                                Former Director in the Ministry of External Affairs, Mr. Kapila has successfully and skillfully handled varied positions in the Consular, Passport & Visa, Security, Gulf, Protocol, and Establishment Wings in the Ministry. He also served as Regional Passport Officer, Delhi and as Addl. P.S. to External Affairs Minister/Minister of State. He has held different positions in Indian Missions abroad in various capacities, i.e., Administration in Embassy of India, Rome, High Commission of India, Bangladesh, Consular( Passports, Visa & Commercial )in Consulate General of India, Dubai Head of Chancery in Embassy of India, Brasilia Counselor, Visa/Head of Chancery in High Commission of India, London. With SuperbWorldTrip since 2015, Mr. Kapila has been one of the leaders in the company helping it to attain its present prominence. It is his vision to make SuperWorldTrip the best travel portal where the customer is at the centre stage, who will be able to seamlessly navigate and fulfill any of his travel needs. Mr. Kapila likes to work in a challenging atmosphere that provides ample opportunities to keep learning in new areas for growth and to utilize his skills to the best of ability and explore all the possibilities to achieve excellence. He always believed in the team work and has done so in all the organizations, he is patient in listening to and dealing with others.
                                            </>
                                        ) : (
                                            <>
                                                Former Director in the Ministry of External Affairs, Mr. Kapila has successfully and skillfully handled varied positions in the Consular, Passport & Visa, Security, Gulf, Protocol, and Establishment Wings in the...
                                            </>
                                        )}
                                    </p>
                                    <button className='read_btn' onClick={() => toggleText('paragraph2')} aria-label="readmore">
                                        {showFullText.paragraph2 ? (
                                            <>
                                                Read Less <FaChevronUp />
                                            </>
                                        ) : (
                                            <>
                                                Read More <FaChevronDown />
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className='member_card'>
                                <img loading="lazy" src={Amarendra_Khatua} alt="" width={200} className='member_img' />
                                <div>
                                    <h2>Mr. Amarendra Khatua, IFS (Retd.)</h2>
                                    <h4 className='mb-2'>Strategic Planning Advisor</h4>
                                    <p>
                                        {showFullText.paragraph3 ? (
                                            <>
                                                Former Secretary, Ministry of External Affairs (Govt. Of India), Former Director General, Indian Council for Cultural Affairs; former Dean, Foreign Service Institute of India and former Ambassador of India to Argentina, Uruguay, Paraguay, Ivory Coast, Guinea, Liberia and Sierra Leone. His experience in India includes service in the Ministry of Commerce and Industry and Planning Commission and in the Finance, Administration, Latin Americas and Nepal, Bhutan divisions of Ministry of External Affairs. A widely travelled man, Ambassador Khatua’s years of experience worldwide, as well as in India, gives him a strategic eye on the tourism industry and what moves it. He brings in his knowledge to guide and help plan the Company’s mission to make SuperWorldTrip the most recognized travel brand in the country.
                                            </>
                                        ) : (
                                            <>
                                                Former Secretary, Ministry of External Affairs (Govt. Of India), Former Director General, Indian Council for Cultural Affairs; former Dean, Foreign Service Institute of India and former Ambassad...
                                            </>
                                        )}
                                    </p>
                                    <button className='read_btn' onClick={() => toggleText('paragraph3')} aria-label="readless">
                                        {showFullText.paragraph3 ? (
                                            <>
                                                Read Less <FaChevronUp />
                                            </>
                                        ) : (
                                            <>
                                                Read More <FaChevronDown />
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className='member_card'>
                                <img loading="lazy" src="https://seplgroup.com/assets/images/mang7.png" alt="" width={200} className='member_img' />
                                <div>
                                    <h2>Mr. Subir Dutta, IFS(retd)</h2>
                                    <h4 className='mb-2'>Director (HR)</h4>
                                    <p>
                                        {showFullText.paragraph4 ? (
                                            <>
                                                Former Ambassador of India to Madagascar and Union of Comoros, Mr. Dutta has over 35 years of experience of serving in the Ministry of External Affairs and in various Indian Embassies abroad. His area of work included passport and visas, information, tourism and publicity, HR and administration as well as politics and diplomacy in various stints in Embassies in Madagascar, Germany, South Korea, Kuwait, Israel, Thailand and Laos. He worked in the administration wing of the Ministry for quite some time besides dealing with politics and developmental assistance in Nepal and countries in West Asia and North Africa. Ambassador Dutta has come on board with his experience and is focused on developing a team geared to cater to the needs of travelers. He knows that travel is a service centric industry and building a team whose main focus is the travelllor is the only way for the company’s progress to greater heights.
                                            </>
                                        ) : (
                                            <>
                                                Former Ambassador of India to Madagascar and Union of Comoros, Mr. Dutta has over 35 years of experience of serving in the Ministry of External Affairs and in various Indian Embassies abro...
                                            </>
                                        )}
                                    </p>
                                    <button className='read_btn' onClick={() => toggleText('paragraph4')} aria-label="show">
                                        {showFullText.paragraph4 ? (
                                            <>
                                                Read Less <FaChevronUp />
                                            </>
                                        ) : (
                                            <>
                                                Read More <FaChevronDown />
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className='member_card'>
                                <img loading="lazy" src="https://seplgroup.com/assets/images/mang6.png" alt="" width={200} className='member_img' />
                                <div>
                                    <h2>Mr. Syed Mahmood Akhter, IRS(retd )</h2>
                                    <h4 className='mb-2'>Director(Coord) </h4>
                                    <p>
                                        {showFullText.paragraph5 ? (
                                            <>
                                                Former, Joint Secretary/Commissioner(Customs & Central Excise), Mr. Akhter has over 35 years of experience in bureaucracy, revenue augmentation and management, soft power diplomacy and trade negotiation. Widely travelled across Europe, USA, South East Asia, UAE, Saudi Arabia and SAARC countries, including a stint as Trade and Commerce Counselor at Indian consulate in Nepal. In order to foster the growth of the company's business, Mr. Akhter has contributed his creative energy, boundless passion, and exceptional networking skills. He envisions SuperworldTrip as one of the best knowm travel portals, which he believes can be achieved by strategic business development, to which he is focused.
                                            </>
                                        ) : (
                                            <>
                                                Former, Joint Secretary/Commissioner(Customs & Central Excise), Mr. Akhter has over 35 years of experience in bureaucracy, revenue augmentation and management, soft power diplomacy an...
                                            </>
                                        )}
                                    </p>
                                    <button className='read_btn' onClick={() => toggleText('paragraph5')} aria-label="remove">
                                        {showFullText.paragraph5 ? (
                                            <>
                                                Read Less <FaChevronUp />
                                            </>
                                        ) : (
                                            <>
                                                Read More <FaChevronDown />
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className='member_card'>
                                <img loading="lazy" src="https://seplgroup.com/assets/images/mang5.png" alt="" width={200} className='member_img' />
                                <div>
                                    <h2>Mr. Syed Tufail Ahmad</h2>
                                    <h4 className='mb-2'>General Manager</h4>
                                    <p>
                                        {showFullText.paragraph6 ? (
                                            <>
                                                Having joined the company in August 2016, Mr. Tufail Ahmad has been looking after the business development. He has over 18 years of experience and related fields specializing in recruitment, business development and HR issues. His dynamism and affable personality combine to take the company to greater heights. He is focussed on business development initiatives to enhance company revenue streams. He is strong on maintaining relationship and market analysis. He holds an MPhil degree in Management and is an MBA in HR from Osmania University.
                                            </>
                                        ) : (
                                            <>
                                                Having joined the company in August 2016, Mr. Tufail Ahmad has been looking after the business development. He has over 18 years of experience and related fields specializing in recruitment, busi...
                                            </>
                                        )}
                                    </p>
                                    <button className='read_btn' onClick={() => toggleText('paragraph6')} aria-label="show more">
                                        {showFullText.paragraph6 ? (
                                            <>
                                                Read Less <FaChevronUp />
                                            </>
                                        ) : (
                                            <>
                                                Read More <FaChevronDown />
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className='member_card'>
                                <img loading="lazy" src={Shaquib_Raza} alt="" width={200} className='member_img' />
                                <div>
                                    <h2>Mr. Shaquib Raza Ansari</h2>
                                    <h4 className='mb-2'>Manager - Operations</h4>
                                    <p>
                                        {showFullText.paragraph7 ? (
                                            <>
                                                Mr. Shaquib Raza Ansari is in charge of operations in SuperbWorldTrip since September 2019. He has close to 18 years of experience in the travel industry and is experienced in all aspects of the trade including ticketing. Reservations, client management and travel consultancy. He also comes with knowledge of corporate travel operations in an international setting. He is well-versed in every aspect of the travel industry, and his strong points include customer service, retention, and operations and delivery. His vision is to ensure optimum service to each travelor so that no one leaves SuperbWorldTrip unhappy. Mr. Ansari is a computer applications graduate and holds an MBA degree on information technology.
                                            </>
                                        ) : (
                                            <>
                                                Mr. Shaquib Raza Ansari is in charge of operations in SuperbWorldTrip since September 2019. He has close to 18 years of experience in the travel industry and is experienced in all aspects of the trade includ...
                                            </>
                                        )}
                                    </p>
                                    <button className='read_btn' onClick={() => toggleText('paragraph7')} aria-label="show less">
                                        {showFullText.paragraph7 ? (
                                            <>
                                                Read Less <FaChevronUp />
                                            </>
                                        ) : (
                                            <>
                                                Read More <FaChevronDown />
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className='member_card'>
                                <img loading="lazy" src={Pratyush_Kumar} alt="" width={200} className='member_img' />
                                <div>
                                    <h2>Mr. Pratyush Kumar</h2>
                                    <h4 className='mb-2'>Branch Manager, Chennai.</h4>
                                    <p>
                                        {showFullText.paragraph8 ? (
                                            <>
                                                Mr. Kumar joined the company in February, 2020 and has since been managing the Chennai branch. He brings with him over 13 years of experience in the travel and tourism industry in dealing with MICE, outbound operations, client relationship management etc. He is tasked with developing customer centric ideas and innovations for every travelor. He has been on the forefront creating innovative packages for enhancing customer experiences. He is a graduate in Tourism studies, holds a PGDM in Travel and Tourism Management as well as a Diploma in Aviation Hospitality and Travel management.
                                            </>
                                        ) : (
                                            <>
                                                Mr. Kumar joined the company in February, 2020 and has since been managing the Chennai branch. He brings with him over 13 years of experience in the travel and tourism industry in dealing with MIC...
                                            </>
                                        )}
                                    </p>
                                    <button className='read_btn' onClick={() => toggleText('paragraph8')} aria-label="visible">
                                        {showFullText.paragraph8 ? (
                                            <>
                                                Read Less <FaChevronUp />
                                            </>
                                        ) : (
                                            <>
                                                Read More <FaChevronDown />
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className='member_card'>
                                <img loading="lazy" src={Bader_Uddin} alt="" width={200} className='member_img' />
                                <div>
                                    <h2>Mr. Mohd. Bader Uddin (Aamir)</h2>
                                    <h4 className='mb-2'>Sr. Sales Manager, Hyderabad.</h4>
                                    <p>
                                        {showFullText.paragraph9 ? (
                                            <>
                                                Mohd. Bader Uddin (Aamir) has been with the company for over a year and has been instrumental in forging substantial increase in sales. He comes with 14 years of experience in the hospitality industry including international experience in a Sheraton chain hotel. He has extensive know-how in corporate travel and MICE tourism. SWT draws on his knowledge for group travels. He aims to use engaging social media content, innovative payment solutions and a personalised booking experience to increase sales.
                                            </>
                                        ) : (
                                            <>
                                                Mohd. Bader Uddin (Aamir) has been with the company for over a year and has been instrumental in forging substantial increase in sales. He comes with 14 years of experience in the hospitality indu...
                                            </>
                                        )}
                                    </p>
                                    <button className='read_btn' onClick={() => toggleText('paragraph9')} aria-label="hidden">
                                        {showFullText.paragraph9 ? (
                                            <>
                                                Read Less <FaChevronUp />
                                            </>
                                        ) : (
                                            <>
                                                Read More <FaChevronDown />
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </section>

                <section className="container-fluid" style={{ width: '96%', margin: '0 auto 70px' }}>
                    <Row gutter={20}>
                        <Col md={12}>
                            <div className="SWT_text">
                                <h2>Recognition & Certification</h2>
                                <p>SuperbWorldTrip has been climbing the success ladder steadily. Our efforts have been recognized in the form of these recognitions and certification:</p>
                                <p>IATA, TripAdvisor certifications (Attachment)</p>
                                <p>Venture out on a journey like never before with exceptional services from SuperbWorldTrip. Whether you are chasing adventure, seeking tranquility, a serene vacation, a religious pilgrimage or the most important business meeting/conference, we have you covered. We provide a one-stop solution for all your travel needs, from flights and hotels to cabs and buses, we offer the best deals. We also offer corporate travel, MICE services, travel insurance, and visa assistance to ensure a hassle-free experience.</p>
                                <p>Explore every destination deeply, experience the culture, embrace its beauty and create memories of a lifetime with seamless services from SuperbWorldTrip.</p>
                                <Link to='/certificates' className='btn btn-primary'>See more</Link>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="SWT_app">
                                <CertificatesCarousel slidess={Certificates} interval={5000} />
                            </div>
                        </Col>
                    </Row>
                </section>

                <section className="featured_in mb-4">
                    <div className='container'>
                        <Row gutter={20} className='headline_cntr text-center mb-5'>
                            <Col md={3}> </Col>
                            <Col md={18}>
                                <h2 className="title mb-2">Featured In</h2>
                                <p>Meet the visionary leaders behind SuperbWorldTrip! Our management comprises industry veterans who bring decades of experience, passion, and innovation into every journey we curate. Their commitment to delivering exceptional travel experiences lies at the heart of everything we do.</p>
                            </Col>
                        </Row>
                        <Row gutter={20}>
                            <Col md={24} className='text-center'>
                                <div className="featured-logo">
                                    <Carousel
                                        autoplay
                                        dots={false}
                                        slidesToShow={5} // default desktop slides
                                        slidesToScroll={1}
                                        responsive={[
                                            {
                                            breakpoint: 768, // screen width <= 768px
                                            settings: {
                                                slidesToShow: 2, // show 1 slide on mobile
                                                slidesToScroll: 1,
                                            },
                                            },
                                        ]}
                                    >
                                        <div>
                                                <img
                                                    src={the}
                                                    alt="THE"
                                                    loading="eager"
                                                    decoding="async"
                                                />
                                        </div>
                                        <div>
                                                <img
                                                src={BusinessStandard}
                                                alt="Business Standard"
                                                    loading="eager"
                                                    decoding="async"
                                                />
                                        </div>
                                        
                                        <div>
                                                <img
                                                src={DailyHunt}
                                                alt="Daily Hunt"
                                                    loading="eager"
                                                    decoding="async"
                                                />
                                        </div>
                                        
                                        <div>
                                                <img
                                                src={ani}
                                                alt="ANI"
                                                    loading="eager"
                                                    decoding="async"
                                                />
                                        </div>
                                        
                                        <div>
                                                <img
                                                src={ThePrint}
                                                alt="The Print"
                                                    loading="eager"
                                                    decoding="async"
                                                />
                                        </div>
                                    </Carousel>
                                </div>
                                <Link to="/featured-in" aria-label="Featured" className='btn btn-primary'>See more</Link>
                            </Col>
                        </Row>
                    </div>
                </section>

                <section className='contact_area ptb-70'>
                    <div className='container'>
                        <Row gutter={20} className='align-items-center'>
                            <Col md={11}>
                                <div className="headline_cntr mb-5">
                                    <h2 className="title mb-4">Get in touch with SWT</h2>
                                    <p>
                                        Have questions or need assistance? Our dedicated team is eager to hear from you! Whether you're looking for
                                        support, interested in our services, or simply want to share your travel stories, we're all ears.
                                        Drop us a message, and let's make travel memorable.
                                    </p>
                                </div>
                            </Col>
                            <Col md={1}>
                            </Col>
                            <Col md={12}>
                                <Card>
                                    <form action="">
                                        <Row gutter={20}>
                                            <Col md={12} xs={24}>
                                                <div className='form-group mb-2'>
                                                    <label htmlFor="">Your first name</label>
                                                    <input type="text" placeholder='' className='form-control rounded' />
                                                </div>
                                            </Col>
                                            <Col md={12} xs={24}>
                                                <div className='form-group mb-2'>
                                                    <label htmlFor="">Your last name</label>
                                                    <input type="text" placeholder='' className='form-control rounded' />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row gutter={20}>
                                            <Col md={12} xs={24}>
                                                <div className='form-group mb-2'>
                                                    <label htmlFor="">Your Phone</label>
                                                    <input type="text" placeholder='' className='form-control rounded' />
                                                </div>
                                            </Col>
                                            <Col md={12} xs={24}>
                                                <div className='form-group mb-2'>
                                                    <label htmlFor="">Your Email</label>
                                                    <input type="text" placeholder='' className='form-control rounded' />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row gutter={20}>
                                            <Col md={24} xs={24}>
                                                <div className='form-group mb-2'>
                                                    <label htmlFor="">Company</label>
                                                    <input type="text" placeholder='' className='form-control rounded' />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row gutter={20}>
                                            <Col md={24} xs={24}>
                                                <div className='form-group mb-4'>
                                                    <label htmlFor="">Leave us a message</label>
                                                    <textarea className='form-control w-100 rounded'></textarea>
                                                </div>
                                            </Col>
                                        </Row>
                                        <a href='#' className='btn btn-primary'>Send Message</a>
                                    </form>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </section>

                <section className='contact_map_area ptb-70 pb-2'>
                    <div className='container'>
                        <Row gutter={20} className='justify-content-center'>
                            <Col md={12}>
                                <div className="mb-md-5 mb-3 text-center">
                                    <h2 className="fs-1">Contact Us</h2>
                                    <p>We would love to hear from you.</p>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={20} className='align-items-center'>
                            <Col md={24}>
                                <Card>
                                    <Row gutter={24} className='text-center mb-4'>
                                        <Col md={8} xs={24} className='mb-3 mb-md-0'>
                                            <h2 className='mb-2'>Opening Hours</h2>
                                            <p>Mon-Fri</p>
                                            <p>9:00 am - 6:00 pm (GST)</p>
                                        </Col>
                                        <Col md={8} xs={24} className='mb-3 mb-md-0'>
                                            <h2 className='mb-2'>Contact</h2>
                                            <p>+91-9312241999, +91-11-41855999</p>
                                            <p>Fax : +91-11-23350999</p>
                                            <p>flightbooking@SuperbWorldTrip.com</p>
                                        </Col>
                                        <Col md={8} xs={24} className='mb-3 mb-md-0'>
                                            <h2 className='mb-2'>Address</h2>
                                            <p>SuperbWorldTrip Pvt. Ltd., Second floor, Rear Wing Nehru House, 4 Bahadur Shah Zafar Marg , Near ITO Metro Station Gate no. 4 ITO, New Delhi -110002</p>
                                        </Col>
                                    </Row>
                                    <Row gutter={24} className='text-center'>
                                        <Col md={24} className='mb-2'>
                                            <ul className="social_media d-flex align-items-center justify-content-center gap-3 mb-md-0">
                                                <li><a href="https://www.facebook.com/superbworldtrip" target='_blank' aria-label="Facebook"><FaFacebookF /></a></li>
                                                <li><a href="https://x.com/superbworldtrip" target='_blank' aria-label="Twitter"><FaTwitter /></a></li>
                                                <li><a href="https://www.instagram.com/superbworldtrip/" target='_blank' aria-label="Instagram"><FaInstagram /></a></li>
                                                <li><a href="https://www.youtube.com/@Superbworldtrip/" target='_blank' aria-label="Youtube"><FaYoutube /></a></li>
                                                <li><a href="https://www.linkedin.com/company/superb-world-trip/" target='_blank' aria-label="Telegram"><FaLinkedinIn /></a></li>
                                            </ul>
                                        </Col>
                                        <Col xs={24} className='mt-4'>
                                            {/* <MapComponent /> */}
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14007.92383204068!2d77.2415974!3d28.6303328!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x91a5c846909a7809!2sSuperbWorldTrip!5e0!3m2!1sen!2sin!4v1556512343093!5m2!1sen!2sin" frameborder="0" style={{ width: '100%', height: '340px' }}></iframe>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>

                    </div>
                </section>

                <section className='gallery_area ptb-70'>
                    <div className='container'>
                        <Row gutter={20} className='justify-content-center'>
                            <Col md={12}>
                                <div className="mb-md-5 mb-3 text-center">
                                    <h2 className="fs-1 mb-2">Showcasing Our Journey</h2>
                                    <p>Explore the milestones, moments, and achievements that define who we are. A glimpse into our story through captivating visuals.</p>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={20} className='align-items-center justify-content-center'>

                            <Col md={24}>
                                <Card>
                                    <Row gutter={20} className='text-center'>
                                        <Col md={8} xs={12}>
                                            <a data-fancybox="dynamic-gallery" href={gallery_1}>
                                                <img loading="lazy" src={gallery_1} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} xs={12}>
                                            <a data-fancybox="dynamic-gallery" href={gallery_2}>
                                                <img loading="lazy" src={gallery_2} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} xs={12}>
                                            <a data-fancybox="dynamic-gallery" href={gallery_3}>
                                                <img loading="lazy" src={gallery_3} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} xs={12}>
                                            <a data-fancybox="dynamic-gallery" href={gallery_4}>
                                                <img loading="lazy" src={gallery_4} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} xs={12}>
                                            <a data-fancybox="dynamic-gallery" href={gallery_5}>
                                                <img loading="lazy" src={gallery_5} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} xs={12}>
                                            <a data-fancybox="dynamic-gallery" href={gallery_6}>
                                                <img loading="lazy" src={gallery_6} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_7}>
                                                <img loading="lazy" src={gallery_7} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_8}>
                                                <img loading="lazy" src={gallery_8} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_9}>
                                                <img loading="lazy" src={gallery_9} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_10}>
                                                <img loading="lazy" src={gallery_10} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_11}>
                                                <img loading="lazy" src={gallery_11} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_12}>
                                                <img loading="lazy" src={gallery_12} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_13}>
                                                <img loading="lazy" src={gallery_13} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_14}>
                                                <img loading="lazy" src={gallery_14} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_15}>
                                                <img loading="lazy" src={gallery_15} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_16}>
                                                <img loading="lazy" src={gallery_16} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_17}>
                                                <img loading="lazy" src={gallery_17} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_18}>
                                                <img loading="lazy" src={gallery_18} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_19}>
                                                <img loading="lazy" src={gallery_19} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_20}>
                                                <img loading="lazy" src={gallery_20} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_21}>
                                                <img loading="lazy" src={gallery_21} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_22}>
                                                <img loading="lazy" src={gallery_22} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_23}>
                                                <img loading="lazy" src={gallery_23} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_24}>
                                                <img loading="lazy" src={gallery_24} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_25}>
                                                <img loading="lazy" src={gallery_25} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_26}>
                                                <img loading="lazy" src={gallery_26} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_27}>
                                                <img loading="lazy" src={gallery_27} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                        <Col md={8} className='d-none'>
                                            <a data-fancybox="dynamic-gallery" href={gallery_28}>
                                                <img loading="lazy" src={gallery_28} alt="gallery" className='img-fluid' />
                                            </a>
                                        </Col>
                                    </Row>
                                    <Row gutter={20}>
                                        <Col xs={24} className='text-center mt-3'>
                                            <a data-fancybox="dynamic-gallery" href={About_Us} className='btn btn-primary px-3'>
                                                Show more
                                            </a>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>

                    </div>
                </section>

                <Modal
                    open={isModalOpen}
                    onCancel={closeModal}
                    footer={null}
                    width={800}
                    centered
                >
                    {selectedMember && (
                        <div className="modal_content">
                            <div className="">
                                <img
                                    src={selectedMember.image}
                                    alt={selectedMember.name}
                                    width={150}
                                    height={180}
                                    style={{ borderRadius: '10px', float: 'left', objectFit: 'cover' }}
                                    className='me-3 '
                                />
                                <div className='management_modal'>
                                    <h2 className='mb-1'>{selectedMember.name}</h2>
                                    <h4 className='mb-2'>{selectedMember.title}</h4>

                                    <p>
                                        {selectedMember.fullText1}
                                        {selectedMember.fullText2 && <b> {selectedMember.fullText2} </b>}
                                        {selectedMember.fullText3}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal>


            </div>

        </>
    )
}

export default AboutUs